import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { OverlayContainer } from '@angular/cdk/overlay';
import { CustomOverlayContainer } from './theme/utils/custom-overlay-container';

import { AgmCoreModule } from '@agm/core';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { PERFECT_SCROLLBAR_CONFIG } from 'ngx-perfect-scrollbar';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { JwtInterceptor } from './helpers/jwt.interceptor';
import { ErrorInterceptor } from './helpers/error.interceptor'
import { AuthenticationService } from './helpers/auth.services'
import { ChatbotComponent } from './pages/chatbot/chatbot.component';

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
    wheelPropagation: true,
    suppressScrollX: true
};

import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';

import { SharedModule } from './shared/shared.module';
import { PipesModule } from './theme/pipes/pipes.module';
import { AppRoutingModule } from './app.routing';

import { AppSettings } from './app.settings';
import { AppComponent } from './app.component';
import { PagesComponent } from './pages/pages.component';
import { BlankComponent } from './pages/blank/blank.component';
import { SearchComponent } from './pages/search/search.component';
import { NotFoundComponent } from './pages/errors/not-found/not-found.component';
import { ErrorComponent } from './pages/errors/error/error.component';

import { TopInfoContentComponent } from './theme/components/top-info-content/top-info-content.component';
import { SidenavComponent } from './theme/components/sidenav/sidenav.component';
import { VerticalMenuComponent } from './theme/components/menu/vertical-menu/vertical-menu.component';
import { HorizontalMenuComponent } from './theme/components/menu/horizontal-menu/horizontal-menu.component';
import { FlagsMenuComponent } from './theme/components/flags-menu/flags-menu.component';
import { FullScreenComponent } from './theme/components/fullscreen/fullscreen.component';
import { ApplicationsComponent } from './theme/components/applications/applications.component';
import { MessagesComponent } from './theme/components/messages/messages.component';
import { UserMenuComponent } from './theme/components/user-menu/user-menu.component';
import { FavoritesComponent } from './theme/components/favorites/favorites.component';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { SharedService } from './shared/shared.service';
import { SequenceComponent } from './pages/master/sequence/sequence.component';
import { ContractorComponent } from './pages/master/contractor/contractor.component';
import { ConfirmationMessageComponent } from './pages/comman-components/confirmation-message/confirmation-message.component';
import { MasterService } from './pages/master/master.service';
import { ConfirmationWithReasonComponent } from './pages/comman-components/confirmation-with-reason/confirmation-with-reason.component';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { StompService } from './services/stomp.service';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { StockadjustmentAddComponent } from './pages/stockAdjustment/stockadjustment-add/stockadjustment-add.component';
import { MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { APP_DATE_FORMATS } from './utility/app-date-format';
import { ContractorPaymentRequestListComponent } from './pages/SubContractor/contractor_payment_request/contractor-payment-request-list/contractor-payment-request-list.component';
import { ContractorPaymentRequestAddComponent } from './pages/SubContractor/contractor_payment_request/contractor-payment-request-add/contractor-payment-request-add.component';
import { FileUploadDialogComponent } from './pages/prn-entry/file-upload-dialog/file-upload-dialog.component';
//import { AddEquipmentComponent } from './pages/dpr-entry/add-equipment/add-equipment.component';
import { ProjectAndContractDetailsComponent } from './pages/prn-entry/project_and_contract_details/project-and-contract-details/project-and-contract-details.component';
import { KickOffMeetingFormComponent } from './pages/kick-off-meeting/kick-off-meeting-form/kick-off-meeting-form.component';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';

import { MaterialReturnToGodownAddComponent } from './pages/materialReturn/material-return-to-godown/material-return-to-godown-add/material-return-to-godown-add.component';
//import { MaterialReturnToGodownListComponent } from './pages/materialReturn/material-return-to-godown/material-return-to-godown-list/material-return-to-godown-list.component';
import { MatSelectFilterModule } from 'mat-select-filter';
import { DlpListComponent } from './pages/dlp/dlp-list/dlp-list.component';
import { MicrosoftCallbackComponent } from './pages/microsoft-callback/microsoft-callback.component';
import { WoTypeListComponent } from './pages/master/wo-type/wo-type-list/wo-type-list.component';
import { WoTypeDialogComponent } from './pages/master/wo-type/wo-type-dialog/wo-type-dialog.component';
//import { YearInterceptor } from './helpers/year.interceptor';
import { YearInterceptor } from './helpers/year.interceptor';
//import { DlpListComponent } from './pages/dlp/dlp-list/dlp-list.component';


// import { ImportLogListComponent } from './pages/log/import-log/import-log-list/import-log-list.component';
//import { SupplierBillEntryListComponent } from './pages/supplier-bill-entry/supplier-bill-entry-list/supplier-bill-entry-list.component';
//import { SupplierBillEntryAddComponent } from './pages/supplier-bill-entry/supplier-bill-entry-add/supplier-bill-entry-add.component';


@NgModule({
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        FormsModule,
        ReactiveFormsModule,
        MatAutocompleteModule,
        HttpClientModule,
        AgmCoreModule.forRoot({
            apiKey: 'AIzaSyAO7Mg2Cs1qzo_3jkKkZAKY6jtwIlm41-I'
        }),
        PerfectScrollbarModule,
        CalendarModule.forRoot({
            provide: DateAdapter,
            useFactory: adapterFactory
        }),
        SharedModule,
        PipesModule,
        AppRoutingModule,
        MatSnackBarModule,

        MatFormFieldModule, 
        MatSelectModule
    ],
    declarations: [
        AppComponent,
        PagesComponent,
        BlankComponent,
        SearchComponent,
        NotFoundComponent,
        ErrorComponent,
        TopInfoContentComponent,
        SidenavComponent,
        VerticalMenuComponent,
        HorizontalMenuComponent,
        FlagsMenuComponent,
        FullScreenComponent,
        ApplicationsComponent,
        MessagesComponent,
        UserMenuComponent,
        FavoritesComponent,
        SequenceComponent,
        ContractorComponent,
        ConfirmationMessageComponent,
        ConfirmationWithReasonComponent,
        ContractorPaymentRequestListComponent,
        ContractorPaymentRequestAddComponent,
        FileUploadDialogComponent,
        //AddEquipmentComponent,
        ProjectAndContractDetailsComponent,
       // KickOffMeetingFormComponent,

        ChatbotComponent,
        DlpListComponent,
    //   LaborMasterListComponent,
    // LaborMasterDialogComponent,
      
    //    MaterialReturnToGodownAddComponent,
    //    MaterialReturnToGodownListComponent, 

       // ChatbotComponent, 
       // DlpListComponent
        //  ContractorAdvancePaymentDialogComponent,
      
       
        // ImportLogListComponent,
       //    SupplierBillEntryListComponent,
    //    SupplierBillEntryAddComponent,
     MicrosoftCallbackComponent,
    ],
    providers: [
        AppSettings,
        { provide: PERFECT_SCROLLBAR_CONFIG, useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG },
        { provide: OverlayContainer, useClass: CustomOverlayContainer },
        { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: YearInterceptor, multi: true },
        { provide: LocationStrategy, useClass: HashLocationStrategy },
        { provide: MAT_DATE_LOCALE, useValue: 'en-GB' }, // Set locale (Optional, if needed)
        { provide: MAT_DATE_FORMATS, useValue: APP_DATE_FORMATS },
        {
    provide: HTTP_INTERCEPTORS,
    useClass: YearInterceptor,
    multi: true
  },
        AuthenticationService,
        SharedService,
        StompService,
        MasterService
    ],
    bootstrap: [
        AppComponent
    ]
})
export class AppModule { }
